var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPadlock = function SvgPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.45671V5.48099C3 3.32466 4.79 1.57812 7 1.57812C9.21 1.57812 11 3.32466 11 5.48099V6.45671",
    stroke: "#002010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.45654H2.125C1.50368 6.45654 1 6.94799 1 7.55423V14.1403C1 14.7466 1.50368 15.238 2.125 15.238H11.875C12.4963 15.238 13 14.7466 13 14.1403V7.55423C13 6.94799 12.4963 6.45654 11.875 6.45654Z",
    stroke: "#002010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.3595C7.27614 10.3595 7.5 10.1411 7.5 9.87165C7.5 9.60221 7.27614 9.38379 7 9.38379C6.72386 9.38379 6.5 9.60221 6.5 9.87165C6.5 10.1411 6.72386 10.3595 7 10.3595Z",
    stroke: "#002010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.87158V12.3109",
    stroke: "#002010",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPadlock;